import theme from "assets/theme";
import React from "react";
import { StyleSheet, Text, View } from "react-native";

const classes = StyleSheet.create({
  relatedAlertsContainer: {
    marginTop: 20,
    width: "100%",
  },
  relatedAlertsLabelContainer: {
    marginBottom: 10,
  },
  label: {
    fontWeight: theme.font.weight.medium,
    color: theme.color.darkGrey,
    paddingBottom: 8,
  },
  content: {
    fontWeight: theme.font.weight.regular,
    color: theme.color.darkGrey,
    paddingLeft: 24,
    paddingBottom: 8,
  },
  noAlertsText: {
    fontWeight: theme.font.weight.regular,
    color: theme.color.darkGrey,
    paddingLeft: 24,
    paddingBottom: 8,
    fontStyle: "italic",
  },
});

export default function RelatedAlerts({
  alerts = [],
  entityType = "Entity",
  style = {},
}) {
  return (
    <View style={[classes.relatedAlertsContainer, style]}>
      <View style={classes.relatedAlertsLabelContainer}>
        {alerts.length > 0 && (
          <Text style={classes.label}>
            Active Alerts Affecting this {entityType}:
          </Text>
        )}
      </View>
      <View>
        {alerts.length > 0 ? (
          alerts.map((alert) => (
            <Text key={alert.alertId} style={classes.content}>
              • {alert.title}
            </Text>
          ))
        ) : (
          <Text style={classes.noAlertsText}>
            No active alerts affecting this {entityType.toLowerCase()}.
          </Text>
        )}
      </View>
    </View>
  );
}
